export default __webpack_public_path__ + "static/media/Matthias-Eibinger.fe1effc0.png";